import { cn } from "@/lib/utils"
import Lottie from "lottie-react"
import loadingAnimation from "@/assets/blue.json"

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl"
  className?: string
  text?: string
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6", 
  lg: "h-8 w-8",
  xl: "h-12 w-12",
  "2xl": "h-16 w-16",
  "3xl": "h-24 w-24",
  "4xl": "h-32 w-32"
}

const textSizeClasses = {
  sm: "text-xs",
  md: "text-sm",
  lg: "text-sm",
  xl: "text-base",
  "2xl": "text-lg",
  "3xl": "text-xl",
  "4xl": "text-2xl"
}

export function LoadingSpinner({ size = "md", className, text }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center space-y-4">
      <div className={cn("flex items-center justify-center", sizeClasses[size], className)}>
        <Lottie animationData={loadingAnimation} loop={true} />
      </div>
      {text && (
        <p className={cn("text-muted-foreground animate-pulse font-medium", textSizeClasses[size])}>{text}</p>
      )}
    </div>
  )
}

interface PageLoadingProps {
  text?: string
  className?: string
}

export function PageLoading({ text = "Loading...", className }: PageLoadingProps) {
  return (
    <div className={cn("flex items-center justify-center min-h-[400px]", className)}>
      <LoadingSpinner size="lg" text={text} />
    </div>
  )
}

interface InlineLoadingProps {
  text?: string
  size?: "sm" | "md" | "lg"
  className?: string
}

export function InlineLoading({ text, size = "sm", className }: InlineLoadingProps) {
  return (
    <div className={cn("flex items-center space-x-2", className)}>
      <div className={cn("flex items-center justify-center", sizeClasses[size])}>
        <Lottie animationData={loadingAnimation} loop={true} />
      </div>
      {text && <span className="text-sm text-muted-foreground">{text}</span>}
    </div>
  )
}
